export function ProgressBar({ value = 0, max = 100, label = "", showPercent = true, colour = "#4f8ef7" }) {
    const percent = Math.min(100, Math.max(0, (value / max) * 100));

    return (
        <div className="progress-wrapper">
            {(label || showPercent) && (
                <div className="progress-header">
                    {label && <span className="progress-label">{label}</span>}
                    {showPercent && <span className="progress-percent">{Math.round(percent)}%</span>}
                </div>
            )}
            <div
                className="progress-track"
                role="progressbar"
                aria-valuenow={value}
                aria-valuemin={0}
                aria-valuemax={max}
                aria-label={label || "progress"}
            >
                <div
                    className="progress-fill"
                    style={{
                        width: `${percent}%`,
                        backgroundColor: colour,
                        transition: "width 0.3s ease"
                    }}
                />
            </div>
        </div>
    );
}